export default __webpack_public_path__ + "broken-image.svg";